import axios from 'axios'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import CreateNews from './dto/CreateNews'
import GetAllNews from './dto/GetAllNews'
import GetNews from './dto/GetNews'
import {PagedNewsResultRequestDto} from './dto/PagedNewsResultRequestDto'
import UpdateNews from './dto/UpdateNews'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/News/Create`
export const URL_DELETE = `${API_URL}/News/Delete`
export const URL_GET = `${API_URL}/News/Get`
export const URL_GET_ALL = `${API_URL}/News/GetPagedAll`
export const URL_UPDATE = `${API_URL}/News/Update`

export function onCreateNews(createNews: CreateNews): Promise<boolean> {
  return axios.post(URL_CREATE, createNews)
}

export function onDeleteNews(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetNews(entityDto: EntityDto): Promise<GetNews> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllNews(
  pagedFilterAndSortedRequest: PagedNewsResultRequestDto
): Promise<PagedResultDto<GetAllNews>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateNews(updateNewsInput: UpdateNews): Promise<boolean> {
  return axios.put(URL_UPDATE, updateNewsInput)
}
